<template>
  <div class="home-page">
    <!-- 非B2B -->
    <div v-if="businessType !== 'payout'" v-loading="loading" ref="balanceWrapper">
      <div style="position: relative;">
        <div class="balance-wrapper" v-if="balancesList.length">
          <div class="balance-title-wrapper">
            <span class="title">{{ $t('message.settlement.availableBalance') }}</span>
            <div class="buttons" v-if="balancesList.length > enableBalanceCount">
              <rhcn-button @click="prevBalance" class="icon-button" size="small" :circle="true"
                :disabled="firstShowBalance === 1"><i class="iconfont prev icon-a-lujingcopybeifen2"></i></rhcn-button>
              <rhcn-button @click="nextBalance" class="icon-button" size="small" :circle="true"
                :disabled="firstShowBalance > (balancesList.length - enableBalanceCount)"><i
                  class="iconfont next icon-a-lujingcopybeifen2"></i></rhcn-button>
            </div>
          </div>
          <div class="balance-list pc" ref="balanceListRef">
            <template v-for="(item, index) in balancesList">
              <div @click="balanceClickHandler(item)" class="balance-item" :key="index"
                :style="{ width: balanceWidth }">
                <div class="balance-item-top">
                  <el-image fit="scale-down" class="currency-img"
                    :src="getCurrencyImage(item.currency) ? require(`@/assets/images/currency/${item.currency}.png`) : ''"></el-image>
                  <span class="currency-name margin-left-8">{{ item.availBalance.currency }}</span>
                </div>
                <div class="amount">{{ item.availBalance.amount }}</div>
              </div>
            </template>
          </div>
          <div class="balance-list mobile">
            <template v-for="(item, index) in balancesList">
              <div @click="balanceClickHandler(item)" class="balance-item" :key="index"
                :style="{ width: balanceWidth }">
                <el-image fit="scale-down" class="currency-img"
                  :src="getCurrencyImage(item.currency) ? require(`@/assets/images/currency/${item.currency}.png`) : ''"></el-image>
                <div class="amount">{{ item.availBalance.amount }}</div>
                <div class="currency-name">{{ item.availBalance.currency }}</div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!-- 手机端 -->
      <div v-loading="loadingStatistics" class="summary-wrapper mobile">
        <div class="summary-item">
          <div class="title">
            <span class="title-txt margin-right-20">{{ $t('message.index.amountStatistics') }}</span>
          </div>
          <div class="content amount-content">
            <div class="amount-box total margin-bottom-10">
              <div class="amount-box-title">
                <p class="amount-type">{{ $t('message.index.totalTxn') }}</p>
                <el-select size="mini" class="currency-select-box currency" v-model="statisticsCurrency" filterable
                  @change="changeStatisticsCurrency">
                  <template v-for="(currency, index) in merchantStatisticsData">
                    <el-option :label="currency.settleCurrency" :value="index" :key="index"></el-option>
                  </template>
                </el-select>
              </div>
              <div class="amount-item">
                <div class="amount-item-desc">{{ $t('message.index.totalTxnAmount') }}
                  <el-popover :placement="'right'" trigger="hover" :content="$t('message.index.totalTxnAmountTip')"
                    class="i-popover">
                    <span class="iconfont icon-tishi003" slot="reference"></span>
                  </el-popover>
                </div>
                <div class="amount-item-value total-amount margin-top-11">{{ showMerchantStatisticsData.totalTxnAmount ?
                  formatMoney(showMerchantStatisticsData.totalTxnAmount) : '0.00' }}</div>
              </div>
              <div class="time">{{ showMerchantStatisticsData.createTime ?
                formatDateDisplay(showMerchantStatisticsData.createTime, 'yyyy-MM-dd') : '' }}</div>
            </div>

            <div class="amount-box">
              <div class="amount-box-title">
                <p class="amount-type yesterday">{{ $t('message.index.yesterdayTxn') }}</p>
                <el-select size="mini" class="currency-select-box currency" v-model="statisticsYesterdayCurrency"
                  filterable @change="changeYesterdayStatisticsCurrency">
                  <template v-for="(currency, index) in merchantYesterdayStatisticsData">
                    <el-option :label="currency.settleCurrency" :value="index" :key="index"></el-option>
                  </template>
                </el-select>
              </div>
              <div class="amount-item">
                <div class="amount-item-desc">{{ $t('message.index.yesterdayTotalAmount') }}
                  <el-popover :placement="'right'" trigger="hover"
                    :content="$t('message.index.yesterdayTotalAmountTip')" class="i-popover">
                    <span class="iconfont icon-tishi003" slot="reference"></span>
                  </el-popover>
                </div>
                <div class="amount-item-value">{{ showMerchantYesterdayStatisticsData.yesterdayTotalAmount ?
                  formatMoney(showMerchantYesterdayStatisticsData.yesterdayTotalAmount) : '0.00' }}</div>
              </div>
              <div class="amount-item padding-top-0 margin-top-1">
                <div class="amount-item-desc">
                  <span>{{ $t('message.index.yesterdayTotalCount') }}</span>
                  <el-popover :placement="'right'" trigger="hover" :content="$t('message.index.yesterdayTotalCountTip')"
                    class="i-popover">
                    <span class="iconfont icon-tishi003" slot="reference"></span>
                  </el-popover>
                </div>
                <div class="amount-item-value">{{ showMerchantYesterdayStatisticsData.yesterdayTotalCount || 0 }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- PC -->
      <div v-loading="loadingStatistics" class="summary-wrapper pc">
        <div class="summary-item">
          <div class="title">
            <span class="title-txt margin-right-20">{{ $t('message.index.amountStatistics') }}</span>
          </div>
          <div class="content amount-content">
            <div class="amount-box total margin-right-14">
              <div class="amount-box-title">
                <p class="amount-type">{{ $t('message.index.totalTxn') }}</p>
              </div>
              <div class="amount-item">
                <div class="amount-item-desc">{{ $t('message.index.totalTxnAmount') }}
                  <el-popover :placement="'right'" trigger="hover" :content="$t('message.index.totalTxnAmountTip')"
                    class="i-popover">
                    <span class="iconfont icon-tishi003" slot="reference"></span>
                  </el-popover>
                </div>
                <div class="amount-item-value total-amount margin-top-11">{{ showMerchantStatisticsData.totalTxnAmount ?
                  formatMoney(showMerchantStatisticsData.totalTxnAmount) : '0.00' }}</div>
              </div>
              <div class="time">{{ showMerchantStatisticsData.createTime ?
                formatDateDisplay(showMerchantStatisticsData.createTime, 'yyyy-MM-dd') : '' }}</div>
              <el-select size="mini" class="currency-select-box currency" v-model="statisticsCurrency" filterable
                @change="changeStatisticsCurrency">
                <template v-for="(currency, index) in merchantStatisticsData">
                  <el-option :label="currency.settleCurrency" :value="index" :key="index"></el-option>
                </template>
              </el-select>
            </div>

            <div class="amount-box">
              <div class="amount-box-title">
                <p class="amount-type yesterday">{{ $t('message.index.yesterdayTxn') }}</p>
              </div>
              <div class="amount-item">
                <div class="amount-item-desc">{{ $t('message.index.yesterdayTotalAmount') }}
                  <el-popover :placement="'right'" trigger="hover"
                    :content="$t('message.index.yesterdayTotalAmountTip')" class="i-popover">
                    <span class="iconfont icon-tishi003" slot="reference"></span>
                  </el-popover>
                </div>
                <div class="amount-item-value">{{ showMerchantYesterdayStatisticsData.yesterdayTotalAmount ?
                  formatMoney(showMerchantYesterdayStatisticsData.yesterdayTotalAmount) : '0.00' }}</div>
              </div>
              <div class="amount-item padding-top-0 margin-top-1">
                <div class="amount-item-desc">
                  <span>{{ $t('message.index.yesterdayTotalCount') }}</span>
                  <el-popover :placement="'right'" trigger="hover" :content="$t('message.index.yesterdayTotalCountTip')"
                    class="i-popover">
                    <span class="iconfont icon-tishi003" slot="reference"></span>
                  </el-popover>
                </div>
                <div class="amount-item-value">{{ showMerchantYesterdayStatisticsData.yesterdayTotalCount || 0 }}</div>
              </div>
              <el-select size="mini" class="currency-select-box currency" v-model="statisticsYesterdayCurrency"
                filterable @change="changeYesterdayStatisticsCurrency">
                <template v-for="(currency, index) in merchantYesterdayStatisticsData">
                  <el-option :label="currency.settleCurrency" :value="index" :key="index"></el-option>
                </template>
              </el-select>
            </div>
          </div>
        </div>
        <div class="attention-item">
          <div class="title">{{ $t('message.index.pending') }}</div>
          <div class="content">
            <div class="tip">{{ $t('message.index.attentionTip') }}</div>
            <div class="tip-list">
              <div class="tip-item" @click="toRefusePage('NEW')">
                <span class="tip-content">{{ $t('message.index.newRefuseTxn') }}</span>
                <div class="right-wrapper">
                  <span v-if="chargebackCount.newCount > 0" class="iconfont icon-warning"></span>
                  <span class="count">{{ chargebackCount.newCount }}</span>
                  <span class="iconfont icon-a-lujingcopybeifen2"></span>
                </div>
              </div>
              <div class="tip-item" @click="toRefusePage('FAF')">
                <span class="tip-content">{{ $t('message.index.refuseTxn') }}</span>
                <div class="right-wrapper">
                  <span v-if="chargebackCount.firstAppealFailedCount > 0" class="iconfont icon-warning"></span>
                  <span class="count">{{ chargebackCount.firstAppealFailedCount }}</span>
                  <span class="iconfont icon-a-lujingcopybeifen2"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 手机端 -->
      <div class="summary-wrapper mobile">
        <div class="attention-item">
          <div class="title">{{ $t('message.index.pending') }}</div>
          <div class="content">
            <div class="tip-list-mobile">
              <div class="tip-item" @click="toRefusePage('NEW')">
                <div class="left-wrapper">
                  <div class="left-top">
                    <span class="iconfont icon-xingzhuangjiehe"></span>
                    <div>
                      <span class="tip-content">{{ $t('message.index.refuseTxnTitle') }}</span>
                      <div class="tip-content-sub">({{ $t('message.index.new') }})</div>
                    </div>
                  </div>
                  <div class="bottom">
                    <span class="count">{{ chargebackCount.newCount }}</span>
                    <span class="unit">{{ $t('message.index.countUnit') }}</span>
                  </div>
                </div>
                <div class="right-wrapper">
                  <el-badge is-dot class="item" v-if="chargebackCount.newCount > 0">
                    <span class="iconfont icon-lujing"></span>
                  </el-badge>
                  <span class="iconfont icon-a-lujingcopybeifen2"></span>
                </div>
              </div>
              <div class="tip-item" @click="toRefusePage('FAF')">
                <div class="left-wrapper">
                  <div class="left-top">
                    <span class="iconfont icon-xingzhuangjiehe2"></span>
                    <div>
                      <span class="tip-content">{{ $t('message.index.refuseTxnTitle') }}</span>
                      <div class="tip-content-sub">({{ $t('message.index.appealFailed') }})</div>
                    </div>
                  </div>
                  <div class="bottom">
                    <span class="count">{{ chargebackCount.firstAppealFailedCount }}</span>
                    <span class="unit">笔</span>
                  </div>
                </div>
                <div class="right-wrapper">
                  <el-badge is-dot class="item" v-if="chargebackCount.firstAppealFailedCount > 0">
                    <span class="iconfont icon-lujing"></span>
                  </el-badge>
                  <span class="iconfont icon-a-lujingcopybeifen2"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="entrance-wrapper">
        <div class="title">{{ $t('message.index.doMore') }}</div>
        <div class="content-list">
          <div class="content-item" v-for="(item, index) in entranceList" :key="index" @click="entry(item)">
            <el-image fit="scale-down" class="icon-img" :src="item.icon"></el-image>
            <span class="text" v-html="$t(item.text)"></span>
          </div>
        </div>
      </div>
    </div>
    <!-- B2B 商户 -->
    <div v-if="businessType === 'payout'" ref="balanceWrapper">
      <div class="total-amount-wrapper">
        <div class="title margin-bottom-20">
          <span>{{ $t('message.index.accountTotalAmount') }}</span>
        </div>
        <div v-loading="totalAmountLoading" class="total-amount-content">
          <div>
            <div class="total-amount-content-top">
              <span class="total-amount margin-right-20">{{ totalAmount !== -1 ? totalAmount :
                $t('message.index.laterAgain') }}</span>
              <el-select size="mini" class="currency-select total-currency-select" v-model="totalAmountCurrency"
                filterable @change="changeTotalAmountCurrency">
                <template v-for="(currency, index) in totalAmountCurrencyList">
                  <el-option :label="currency.label" :value="currency.value" :key="index"></el-option>
                </template>
              </el-select>
            </div>
            <div class="total-amount-content-bottom margin-top-5">
              {{ $t('message.index.totalAmountTips', {
                currency: getCurrencyText(totalAmountCurrency), time:
                  totalAmountLastUpdateTime
              }) }}
            </div>
          </div>
          <!-- <div v-if="balancesList.length > 0">
          <rhcn-button v-if="showRechargeButton" size="small" style="background-color: white" @click="onRecharge">{{$t('message.wallet.recharge')}}</rhcn-button>
          <rhcn-button v-if="showTransferAdd" size="small" type="primary" class="margin-left-20" @click="onTransfer">{{$t('message.wallet.payout')}}</rhcn-button>
        </div> -->
        </div>
      </div>
      <div class="balance-wrapper margin-top-33">
        <div class="balance-title-wrapper">
          <div class="title">
            <span>{{ $t('message.settlement.availableBalance') }}</span>
            <!-- <span class="currency-settings" @click="handleCurrencySettings">{{ $t('message.index.currencySettings') }}</span> -->
          </div>
          <div class="buttons" v-if="balancesList.length > enableBalanceCount">
            <rhcn-button @click="prevBalance" class="icon-button" size="small" :circle="true"
              :disabled="firstShowBalance === 1"><i class="iconfont prev icon-a-lujingcopybeifen2"></i></rhcn-button>
            <rhcn-button @click="nextBalance" class="icon-button" size="small" :circle="true"
              :disabled="firstShowBalance > (balancesList.length - enableBalanceCount)"><i
                class="iconfont next icon-a-lujingcopybeifen2"></i></rhcn-button>
          </div>
        </div>
        <div class="balance-list-wrapper">
          <div v-if="balancesList.length" ref="balanceListRef" class="balance-list pc">
            <template v-for="(item, index) in balancesList">
              <div @click="balanceClickHandler(item)" class="balance-item" :key="index"
                :style="{ width: balanceWidth }">
                <div class="balance-item-top">
                  <el-image fit="scale-down" class="currency-img"
                    :src="getCurrencyImage(item.currency) ? require(`@/assets/images/currency/${item.currency}.png`) : ''"></el-image>
                  <span class="currency-name margin-left-8">{{ item.availBalance.currency }}</span>
                  <el-popover placement="bottom" popper-class="index-balance-item-operation" trigger="hover"
                    :visible-arrow="false">
                    <div class="balance-item-operation-box">
                      <div v-if="showTransferAdd" class="balance-item-operation" @click="onTransfer(item.currency)">
                        {{ $t('message.wallet.payout') }}</div>
                      <div v-if="showRechargeButton" class="balance-item-operation" @click="onRecharge(item.currency)">
                        {{ $t('message.wallet.recharge') }}</div>
                    </div>
                    <template #reference>
                      <div
                        v-if="(showRechargeButton || showTransferAdd) && dict.includes(item.currency)"
                        class="balance-item-operations" @click="noop">
                        <i class="iconfont icon-a-rongqi71x"></i>
                      </div>
                    </template>
                  </el-popover>
                </div>
                <div class="amount">{{ item.availBalance.amount }}</div>
              </div>
            </template>
          </div>
          <div v-if="balancesList.length" class="balance-list mobile">
            <template v-for="(item, index) in balancesList">
              <div @click="balanceClickHandler(item)" class="balance-item" :key="index"
                :style="{ width: balanceWidth }">
                <el-image fit="scale-down" class="currency-img"
                  :src="getCurrencyImage(item.currency) ? require(`@/assets/images/currency/${item.currency}.png`) : ''"></el-image>
                <div class="amount">{{ item.availBalance.amount }}</div>
                <div class="currency-name">{{ item.availBalance.currency }}</div>
              </div>
            </template>
          </div>
          <!-- <div class="add-balance-box" @click="handleAddCurrency">
          <div class="add-balance-top">
            <span class="img"><i class="iconfont icon-xingzhuang"></i></span>
            <span class="add-balance-desc margin-left-8">{{$t('message.index.addOtherCurrency')}}</span>
          </div>
          <div class="add-balance-bottom">
            <span>{{$t('message.index.open')}}</span>
            <i class="iconfont icon-tianjiaka-mian margin-left-8"></i>
          </div>
        </div> -->
        </div>
      </div>
      <div class="txn-list-wrapper">
        <div class="title margin-bottom-20">
          <span>{{ $t('message.index.transaction') }}</span>
          <span v-if="showTransferAll" class="right" @click="handleTransferList">{{ $t('message.searchCommon.all') +
            '>' }}</span>
        </div>
        <custom-table :table-set="tableCondition" ref="table" :is-first-automatic-visit="false"
          :is-pagination-display="false" :service-function="queryTransferTxnList">
          <template #rhcn-empty>
            <empty-component :empty-title="$t('message.index.noTransferTips')">
              <el-button v-if="showTransferAdd" class="margin-top-10" size="small" type="primary" @click="onTransfer">{{
                $t('message.transfer.transferMoney') }}</el-button>
            </empty-component>
          </template>
          <template #payeeName="{ row }">
            <div class="account-name" style="font-weight: 800;">{{ row.payeeAccountName }}</div>
            <!-- <div class="payee-account">{{row.payeeAccount}}</div> -->
          </template>
        </custom-table>
      </div>
    </div>
    <RechargeModal ref="rechargeModal"></RechargeModal>
    <CurrencySettingsModal ref="currencySettings" :balances="allBalanceList" @change="onCurrencySettings">
    </CurrencySettingsModal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { getMerchantAudit } from '@/api/common/user';
import RhcnButton from '@/components/form/button.vue';
import { ShowErrorMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import EmptyComponent from '@/components/table/empty-component.vue';
import GlobalData from '@/utils/global/index';
import { formatMoney, getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { getCurrencyImage, formatAmountByCurrency } from '@/utils/tools/currency';
import { getTodayParams, formatDateDisplay } from '@/utils/tools/time';
import { setLocalStorage } from '@/utils/tools/utils';
import AccountInfo from '@/views/account/information/api/account-info';
import {
  checkPermission, getChargebackList,
  getMerchantStatistics, getMerchantStatisticsYesterday,
  queryStatAccountMoneyTotal,
} from '@/views/index/api/index';
import CurrencySettingsModal from '@/views/index/CurrencySettings.vue';
import RechargeModal from '@/views/index/recharge.vue';
import BalancesService from '@/views/settlement/api/settlement-balance';
import TransferService from '@/views/transfer/api/transfer';

export default {
  components: {
    RhcnButton,
    CustomTable,
    RechargeModal,
    EmptyComponent,
    CurrencySettingsModal,
  },
  data() {
    return {
      loading: false,
      balancesList: [],
      allBalanceList: [],
      enableBalanceCount: 0,
      statisticsCurrency: '', // 金额统计币种
      statisticsYesterdayCurrency: '',
      merchantStatisticsData: [],
      merchantYesterdayStatisticsData: [],
      showMerchantStatisticsData: {},
      showMerchantYesterdayStatisticsData: {},
      currencyList: [],
      firstShowBalance: 1,
      balanceWidth: '100%',
      translateL: 220,
      chargebackCount: {
        newCount: '',
        firstAppealFailedCount: '',
      },
      entranceList: [
        {
          icon: require('../../assets/images/index/operator.png'),
          text: 'message.index.addTeamOperator',
          code: 'account:permission:operator:add',
          path: '/account/permission/operator',
        },
        {
          icon: require('../../assets/images/index/website_management.png'),
          text: 'message.index.websiteManagement',
          code: 'application:list',
          path: '/application/list',
        },
        // {
        //   icon: require('../../assets/images/index/send_money.png'),
        //   text: 'message.index.sendMoney',
        //   code: 'transfer:transfer:add',
        //   path: '/transfer/transfer/add/recipient',
        // },
      ],
      screenWidth: window.screen.width,
      loadingStatistics: false,
      tableCondition: [
        { // Create date
          titleBar: { type: 'text', title: 'message.payee.creationTime' },
          key: 'createTime',
          type: 'text',
        },
        { // Batch no
          titleBar: { type: 'text', title: 'message.transfer.fileBatchNo' },
          key: 'batchNo',
          type: 'text',
        },
        { // Transfer ID
          titleBar: { type: 'text', title: 'message.transfer.transferId' },
          key: 'id',
          type: 'click',
          subTableDisplays: [
            {
              type: 'text_button',
              key: 'id',
              isDisplayFunc: () => {
                return this.isHasTransferViewAuth();
              },
              func: (data) => {
                window.open(`/transfer/transfer/view?id=${data.id}&businessType=${this.businessType}`, '_blank');
              },
            },
            {
              type: 'text',
              key: 'id',
              isDisplayFunc: () => !this.isHasTransferViewAuth(),
            },
          ],
        },
        { // Beneficiary
          titleBar: { type: 'text', title: 'message.transfer.beneficiary' },
          key: 'payeeName',
          type: 'slot',
        },
        { // Send Amount
          titleBar: { type: 'text', title: 'message.transfer.sendAmount' },
          key: 'settleSumAmount',
          type: 'text',
          textFunc: (row) => {
            if (row.settleSumAmount === null) {
              return '--';
            }
            return `${row.settleSumAmount} ${row.settleCurrency}`;
          },
        },
        { // Received Amount
          titleBar: { type: 'text', title: 'message.transfer.amountReceived1' },
          key: 'payoutAmount',
          type: 'text',
          textFunc: (row) => {
            if (!row.payoutAmount) {
              return '--';
            }
            return `${formatAmountByCurrency(row.payoutAmount, row.payoutCurrency)} ${row.payoutCurrency}`;
          },
        },
        { // 付款方式
          titleBar: { type: 'text', title: 'message.transfer.paymentMethod' },
          key: 'payoutMethod',
          type: 'text',
          textFunc: (row) => getEnantiomericValue(this.transferMethodList, row.payoutMethod),
        },
        { // Completion time
          titleBar: { type: 'text', title: 'message.transfer.payTime' },
          key: 'payoutTime',
          type: 'text',
        },
        { // status
          titleBar: { type: 'text', title: 'message.tableCommon.status' },
          key: 'payoutStatus',
          type: 'text',
          textFunc: (row) => getEnantiomericValue(this.payoutStatusList, row.payoutStatus),
          itemStyle: (data) => {
            const style = 'height: 30px;text-align: center;border-radius:4px;font-weight: 800;line-height: 30px;padding: 0 15px;';
            if (data.payoutStatus === 'S') { // 成功
              return `background:rgba(0,221,40,0.15);${style}`;
            } else if (['P', 'A', 'I'].indexOf(data.payoutStatus) > -1) { // 处理中,待审核,初始化
              return `background:rgba(255,178,9,0.15);${style}`;
            } else if (data.payoutStatus === 'C') { // 撤销
              return `background:#F1F5F7;${style}`;
            }
            return `background:rgba(252,100,45,0.15);${style}`; // SF, F, U, E, R
          },
        },
      ],
      payoutStatusList: [],
      transferMethodList: [],
      totalAmountCurrencyList: [{
        label: 'USD',
        value: 'USD',
      }, {
        label: 'GBP',
        value: 'GBP',
      }, {
        label: 'EUR',
        value: 'EUR',
      },
        // {
        //   label: 'JPY',
        //   value: 'JPY',
        // }
      ],
      payoutSupportCurrencyList: [],
      dict: [],
      totalAmountLoading: false,
      totalAmountCurrency: 'USD',
      totalAmount: '0.00',
      totalAmountLastUpdateTime: '',
      showTransferAll: false,
      showTransferView: false,
      showTransferAdd: false,
      showRechargeButton: false,
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
    businessType() {
      return this.$route.params?.type || '';
    },
  },
  created() {
    // 付款商户时，获取付款记录
  },
  mounted() {
    this.initMethods();
  },
  methods: {
    formatMoney,
    getCurrencyImage,
    formatDateDisplay,
    initMethods() {
      // console.log('调用了');
      if (this.businessType === 'payout') {
        this.queryTransferTxnInfo();
        this.fetchStatAccountMoneyTotal();
        checkPermission('transfer:transfer').then((res) => {
          this.showTransferAll = res;
        });
        checkPermission('transfer:transfer:detail').then((res) => {
          this.showTransferView = res;
        });
        checkPermission('transfer:transfer:add').then((res) => {
          this.showTransferAdd = res;
        });
        checkPermission('wallet:balance:recharge').then((res) => {
          this.showRechargeButton = res;
        });
      } else {
        // 拒付个数
        getChargebackList().then((res) => {
          this.chargebackCount = res;
        });
        this.queryMerchantStatistics();
      }
      console.log('demo', this.businessType);
      const width = this.$refs.balanceWrapper.offsetWidth;
      if (this.screenWidth < 992) { // 手机端
        this.translateL = 190;
        this.enableBalanceCount = Math.floor(width / 190);
      } else { // PC端
        if (this.businessType !== 'payout') {
          // width = width - 205;
        }
        this.enableBalanceCount = Math.floor(width / 220);
      }
      const params = {
        businessType: this.businessType ? (this.businessType === 'payout' ? 'PAYOUT' : 'ACQUIRING') : null,
      };
      // const dict = await GlobalData.getDictList(['PAYOUT_SUPPORT_CURRENCY']);
      // 账户余额
      BalancesService.getAccountBalances(params).then((res) => {
        console.log('payoutSupportCurrencyList', this.payoutSupportCurrencyList);
        this.dict = this.payoutSupportCurrencyList.map(item => item.value);
        let list = res;
        if (this.businessType === 'payout') {
          console.log('Payout 商户只展示以下币种'); // Payout 商户只展示以下币种
          list = res.filter(item => this.dict.includes(item.currency));
        }
        console.log('list', list);
        this.allBalanceList = list;
        console.log('balancesList', list);
        this.balancesList = list;
        this.onResizeBalanceList();
      });

      AccountInfo.getAccountInfo().then(async res => {
        const data = {
          ...this.app.userLogin,
          merchantName: res.merchantName,
          merchantStatus: res.status,
          auditStatus: res.auditStatus,
        };
        console.log('res2', res);
        setLocalStorage('BusinessTypes', JSON.stringify(res));
        await this.$store.dispatch('app/setBusinessTypes', res);
        await this.$store.dispatch('app/setjumioUser', res);
        // await this.$store.dispatch('app/setUserLogin', res);
      });
      getMerchantAudit().then(async res => {
        await this.$store.dispatch('app/setjumioStatus', res);
      });
    },
    prevBalance() {
      if (this.firstShowBalance > 1) {
        this.firstShowBalance -= 1;
      }
      const width = parseFloat(this.balanceWidth) || this.translateL;
      this.$refs.balanceListRef.scrollTo({
        left: this.$refs.balanceListRef.scrollLeft - (width < this.translateL ? this.translateL : width),
        behavior: 'smooth',
      });
    },
    nextBalance() {
      if (this.firstShowBalance <= this.balancesList.length - this.enableBalanceCount) {
        this.firstShowBalance += 1;
      }
      const width = parseFloat(this.balanceWidth) || this.translateL;
      console.log('width', this.$refs.balanceListRef);
      this.$refs.balanceListRef.scrollTo({
        left: this.$refs.balanceListRef.scrollLeft + (width < this.translateL ? this.translateL : width),
        behavior: 'smooth',
      });
    },
    toRefusePage(status) { // 待处理
      this.loading = true;
      checkPermission('transaction:refuse').then((res) => {
        this.loading = false;
        if (res === true) {
          this.$router.push({
            path: '/transaction/refuse',
            query: { chargebackStatus: status },
          });
        } else {
          ShowErrorMessage(this.$t('message.index.noPermission'));
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    entry(item) {
      this.loading = true;
      checkPermission(item.code).then((res) => {
        this.loading = false;
        if (res === true) {
          if (item.code === 'account:permission:operator:add') {
            this.$router.push({
              path: item.path,
              query: { action: 'add' },
            });
          } else {
            this.$router.push({
              path: item.path,
            });
          }
        } else {
          ShowErrorMessage(this.$t('message.index.noPermission'));
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    balanceClickHandler(item) {
      this.loading = true;
      checkPermission('wallet:balance:detail').then((res) => {
        this.loading = false;
        if (res === true) {
          this.$router.push({
            path: '/wallet/balance/view',
            query: {
              acntId: item.acntId,
              businessType: this.businessType || '',
              currency: item.currency,
              subAcntType: 'AVAIL',
              ...getTodayParams('beginTime', 'endTime'),
            },
          });
        } else {
          ShowErrorMessage(this.$t('message.index.noPermission'));
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    changeStatisticsCurrency(value) {
      this.showMerchantStatisticsData = this.merchantStatisticsData[value];
    },
    changeYesterdayStatisticsCurrency(value) {
      this.showMerchantYesterdayStatisticsData = this.merchantYesterdayStatisticsData[value];
    },
    async queryMerchantStatistics() {
      this.loadingStatistics = true;
      try {
        // 商户统计信息
        console.log('this.businessType', this.businessType);
        await getMerchantStatistics({ businessType: this.businessType }).then((res) => {
          this.merchantStatisticsData = res;
          if (res.length) {
            this.showMerchantStatisticsData = res[0];
            this.statisticsCurrency = 0;
          }
        });
      } catch (err) {
        //
      }

      try {
        // 商户昨日统计信息
        await getMerchantStatisticsYesterday().then((res) => {
          this.merchantYesterdayStatisticsData = res;
          if (res.length) {
            this.showMerchantYesterdayStatisticsData = res[0];
            this.statisticsYesterdayCurrency = 0;
          }
        });
      } catch (err) {
        //
      }
      this.loadingStatistics = false;
    },
    changeTotalAmountCurrency() {
      this.fetchStatAccountMoneyTotal();
    },
    // 新增 VA 账号
    handleAddCurrency() {
      if (`${this.app.userLogin.merchantStatus}` === '4') { // 未启用时，弹出提示
        this.$bus.$emit('showAuditStatusAlert');
        return;
      }
      this.$router.push('/collection/virtual-account/add');
    },
    handleTransferList() {
      if (this.businessType) {
        this.$router.push(`/transfer/transfer/aggregate/${this.businessType}`);
      } else {
        this.$router.push('/transfer/transfer');
      }
    },
    // 获取付款列表最新的三条数据
    async queryTransferTxnList() {
      return await TransferService.getTransferList({ size: 3, businessType: this.businessType ? (this.businessType === 'payout' ? 'PAYOUT' : 'ACQUIRING') : null });
    },
    // 获取付款信息
    async queryTransferTxnInfo() {
      try {
        const dict = await GlobalData.getDictList(['MER_PAYOUT_STATUS', 'TRANSFER_METHOD', 'PAYOUT_SUPPORT_CURRENCY']);
        this.payoutStatusList = initSelectedData(dict.MER_PAYOUT_STATUS); // 付款状态
        this.transferMethodList = initSelectedData(dict.TRANSFER_METHOD); // 付款方式
        this.payoutSupportCurrencyList = (dict.PAYOUT_SUPPORT_CURRENCY); // 付款支持币种
        console.log('payoutSupportCurrencyList2', this.payoutSupportCurrencyList);
        this.$refs.table.firstVisitHttp();
      } catch (err) {
        //
      }
    },
    async fetchStatAccountMoneyTotal() {
      this.totalAmountLoading = true;
      try {
        const res = await queryStatAccountMoneyTotal({
          currency: this.totalAmountCurrency,
          businessType: this.businessType ? (this.businessType === 'payout' ? 'PAYOUT' : 'ACQUIRING') : null,
        });
        this.totalAmount = res.sumAmount;
        this.totalAmountLastUpdateTime = res.lastUpdateTime;
      } catch (err) {
        this.totalAmount = -1;
      }
      this.totalAmountLoading = false;
    },
    getCurrencyText(currency) {
      if (!currency) {
        return '';
      }
      const text = this.$t('message.currency.' + currency);
      if (!text || text.indexOf('message') > -1) {
        return currency;
      }
      return text;
    },
    isHasTransferViewAuth() {
      return this.showTransferView;
    },
    onRecharge(currency) {
      if (`${this.app.userLogin.merchantStatus}` === '4') { // 未启用时，弹出提示
        this.$bus.$emit('showAuditStatusAlert');
        return;
      }
      // if (currency !== 'USD') {
      //   ShowErrorMessage(this.$t('message.wallet.rechargeTips', { currency }));
      //   return;
      // }
      this.$refs.rechargeModal.openModal(currency);
    },
    onTransfer(currency) {
      // this.$router.push({ path: '/transfer/transfer/add/recipient', query: { currency } });
      if (this.businessType) {
        this.$router.push({ path: `/transfer/transfer/aggregate/${this.businessType}` });
      } else {
        this.$router.push({ path: '/transfer/transfer' });
      }
    },
    onResizeBalanceList() {
      const width = this.$refs.balanceWrapper.offsetWidth;
      const contentWidth = width - (15 * this.balancesList.length - 1);
      this.balanceWidth = `${contentWidth / this.balancesList.length}px`;
      this.firstShowBalance = 1;
      this.$nextTick(() => {
        if (this.$refs.balanceListRef) {
          this.$refs.balanceListRef.scrollTo({
            left: 0,
            behavior: 'smooth',
          });
        }
      });
    },
    onCurrencySettings(item) {
      for (let i = 0; i < this.allBalanceList.length; i++) {
        if (item.currency === this.allBalanceList[i].currency) {
          this.allBalanceList[i].checked = item.checked;
        }
      }
      this.balancesList = this.allBalanceList.filter(item => item.checked);
      this.onResizeBalanceList();
    },
    handleCurrencySettings() {
      this.$refs.currencySettings.openModal();
    },
    noop(e) {
      e.stopPropagation();
    },
  },
  watch: {
    '$route.path': {
      handler() {
        this.initMethods();
      },
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

.balance-wrapper {
  width: 100%;
  margin-bottom: 30px;
  display: inline-block;

  // width: calc(100% - 275px);
  .balance-title-wrapper {
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
    align-items: center;

    .title {
      font-size: 26px;
      font-family: Avenir-Heavy, Avenir;
      font-weight: 800;
      line-height: 36px;

      .currency-settings {
        font-weight: 600;
        font-size: 14px;
        color: $color-primary;
        line-height: 24px;
        margin-left: 20px;
        cursor: pointer;
      }
    }

    .buttons {
      .iconfont {
        font-size: 12px;
        transform: scale(0.67);

        &.prev {
          transform: scale(0.67) rotate(180deg);
        }
      }
    }
  }

  .balance-list-wrapper {
    display: flex;
    align-items: center;
  }

  .balance-list {
    width: 100%;
    height: 130px;
    overflow: hidden;
    transition: all 0.5s ease-in;
    white-space: nowrap;
    position: relative;
    // margin-right: 15px;
    display: flex;
    align-items: center;

    .balance-item {
      position: relative;
      display: inline-flex;
      flex-direction: column;
      justify-content: space-between;
      min-width: 205px;
      height: 130px;
      background-color: $color-balance-bg;
      border-radius: 8px;
      padding: 18px 20px;
      padding-right: 16px;
      box-sizing: border-box;
      margin-right: 15px;
      transition: all 0.5s ease-in;
      cursor: pointer;

      &:hover {
        background-color: #EEF9FF;
      }

      &:last-child {
        margin-right: 0;
      }

      .balance-item-top {
        display: flex;
        align-items: center;
        height: 31px;
      }

      .currency-img {
        height: 24px;
        width: 24px;
        display: block;
      }

      .amount {
        font-size: 22px;
        font-weight: 800;
        line-height: 30px;
      }

      .currency-name {
        flex: 1;
        font-size: 23px;
        font-family: Avenir-Heavy, Avenir;
        font-weight: 800;
        color: $color-text-primary;
      }

      .balance-item-operations {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        background: #FFFFFF;
        box-shadow: 0px 2px 10px 0px rgba(158, 158, 158, 0.3);
        border-radius: 4px;

        .icon-a-rongqi71x {
          font-size: 24px;
          font-weight: 500;
        }
      }
    }

    &.mobile {
      display: none;
    }
  }

  .add-balance-box {
    display: inline-flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 205px;
    height: 130px;
    background-color: $color-balance-bg;
    border-radius: 8px;
    padding: 18px 20px;
    box-sizing: border-box;
    cursor: pointer;

    .add-balance-top {
      display: flex;
      align-items: center;
      height: 31px;
    }

    .img {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      background: #FFFFFF;
      border-radius: 4px;
      color: #C1C7CD;
    }

    .add-balance-desc {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: $color-text-primary;
    }

    .add-balance-bottom {
      font-size: 22px;
      font-family: PingFangTC-Semibold, PingFangTC;
      font-weight: 600;
      color: $color-text-primary;

      .icon-tianjiaka-mian {
        font-size: 22px;
      }
    }
  }
}

.summary-amount-wrapper {
  width: 260px;
  display: inline-block;
  box-sizing: border-box;
  vertical-align: top;

  &.pc {
    float: right;
  }

  &.mobile {
    display: none;
  }

  .title {
    font-size: 26px;
    font-weight: bold;
    line-height: 36px;
    padding-bottom: 10px;
  }

  .content {
    background-color: $color-balance-bg;
    border-radius: 8px;
    padding: 13px 10px 24px;
    height: 166px;
    box-sizing: border-box;

    .time {
      font-size: 14px;
      font-weight: 500;
      line-height: 19px;
    }

    .currency {
      display: block;
    }

    .amount {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      vertical-align: top;

      label {
        font-size: 14px;
        margin-right: 5px;

        .i-popover {
          color: #43618A;
          opacity: 0.7;
        }
      }
    }
  }
}

.summary-wrapper {
  display: flex;
  justify-content: space-between;

  &.mobile {
    display: none;
  }

  &.pc {
    .currency-select-box {
      position: absolute;
      right: 10px;
      bottom: 10px;
      width: 70px;
      font-size: 12px !important;
    }
  }

  .title {
    font-size: 26px;
    font-weight: 800;
    line-height: 37px;
    margin-bottom: 11px;
  }

  .content {
    height: 230px;
    background-color: $color-balance-bg;
    border-radius: 10px;
    padding: 28px 18px;
    box-sizing: border-box;

    &.amount-content {
      display: flex;
    }

    .rate-today {
      padding: 20px;

      .title {
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
      }

      .data-wrapper {
        background-color: $color-white;
        text-align: center;
        padding: 20px 0 30px;
        margin-top: 40px;

        .rate {
          font-size: 26px;
          font-weight: 800;
          color: $color-primary;
          line-height: 36px;
          text-align: center;
          padding: 0 35px 7px;
          border-bottom: 4px solid #B2E2F4;
          ;
          display: inline-block;
        }
      }

      .today-text {
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        margin-top: 24px;
        text-align: right;
      }
    }

    .overview-subtitle {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .summary-item {
    margin-right: 15px;
    flex: 1;
    // flex: 1;
    // .content {
    //   padding: 0;
    //   .overview-title {
    //     display: flex;
    //     align-items: center;
    //     justify-content: space-between;
    //     .currency {
    //       width: 75px;
    //       ::v-deep .el-input__inner {
    //         background-color: $color-txn-currency-bg;
    //       }
    //     }

    //     .right {
    //       color: #264373;
    //       font-weight: 600;
    //       font-size: 14px;
    //     }
    //   }
    // }
    .title {
      display: flex;
      align-items: center;

      .title-txt {
        flex-shrink: 0;
      }
    }

    .time {
      font-size: 14px;
      // font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: $color-text-primary;
    }

    .amount-box {
      position: relative;
      background-color: $color-white;
      box-sizing: border-box;
      border-radius: 8px;
      flex: 1;

      .amount-box-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 0;
        padding-right: 8px;
        border-bottom: 1px solid #F4F6F8;

        .amount-type {
          padding: 2px 10px;
          background-color: rgba(#01A2DD, 0.1);
          border-radius: 0px 6px 6px 0px;
          font-size: 16px;
          font-weight: 400;
        }

        .amount-type.yesterday {
          background-color: rgba(#0135DD, 0.1);
        }

        .currency-select-box {
          width: 80px;
          height: 24px;
          border-radius: 4px;
          line-height: 19px;

          ::v-deep &.el-select .el-input__inner {
            font-weight: bold;
            color: $color-text-primary;
          }
        }
      }

      &.total {
        .amount-item {
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
        }
      }

      .amount-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: $color-text-primary;
        padding: 10px;
        padding-top: 15px;

        &.padding-top-0 {
          padding-top: 0;
        }

        .i-popover {
          display: inline-block;
          color: #43618A;
          opacity: 0.7;
          margin-left: 7px;

          .el-popover__reference {
            height: 14px;
            width: 14px;
          }
        }

        .amount-item-desc {
          display: flex;
          align-items: center;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;

          &.li::before {
            content: '';
            width: 4px;
            height: 4px;
            background: $color-text-primary;
            border-radius: 50%;
            margin-right: 8px;
            margin-left: 10px;
          }
        }

        .amount-item-value {
          font-size: 16px;
          font-weight: 800;
          line-height: 22px;
          color: $color-text-primary;

          &.total-amount {
            font-weight: 800;
            line-height: 27px;
          }
        }
      }

      .time {
        position: absolute;
        bottom: 10px;
        left: 10px;
      }
    }
  }

  .attention-item {
    flex: 1;

    .tip {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      margin-bottom: 3px;
    }

    .tip-list {
      .tip-item {
        cursor: pointer;
        padding: 18px 18px;
        background-color: $color-white;
        font-size: 16px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #264373;
        line-height: 22px;
        margin-top: 17px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .tip-content {
          white-space: nowrap;
        }

        .right-wrapper {
          display: flex;
          align-items: center;
          padding-left: 0 !important;
        }

        .icon-warning {
          color: $color-icon-warn;
          font-size: 26px;
          margin-right: 15px;
        }

        .count {
          font-size: 16px;
          font-weight: 800;
          line-height: 22px;
          margin-right: 20px;
        }

        .icon-a-lujingcopybeifen2 {
          font-size: 12px;
          transform: scale(0.66);
          color: $color-text-default-button;
        }
      }
    }
  }
}

.txn-wrapper {
  &.mobile {
    display: none;
  }

  .title-wrapper {
    display: flex;
    align-items: center;
    padding-top: 38px;
    padding-bottom: 11px;

    .title {
      font-size: 26px;
      font-weight: 800;
      line-height: 37px;
      margin-right: 30px;
    }

    .currency {
      width: 87px;
      margin-right: 20px;
    }

    .time {
      width: 127px;
    }
  }

  .chart-wrapper {
    .txn-title-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .i-popover {
        margin-left: 11px;
        color: #43618A;
        opacity: 0.7;
      }

      .right {
        color: #264373;
        font-weight: 600;
        font-size: 14px;
      }
    }

    .txn-subtitle-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .amount {
        font-size: 16px;
        font-weight: 800;
        color: $color-primary;
      }

      .date {
        font-size: 12px;
        font-weight: 400;
        color: $color-chart-date;
      }
    }
  }
}

.show-today {
  width: 127px;
  height: 32px;
  background: #F4F6F8;
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .icon-eye {
    color: $color-primary;
  }
}

.entrance-wrapper {
  margin-top: 44px;

  .title {
    font-size: 26px;
    font-weight: 800;
    line-height: 36px;
  }

  .content-list {
    display: flex;
    flex-wrap: wrap;

    .content-item {
      width: 230px;
      height: 170px;
      background-color: $color-balance-bg;
      margin-right: 15px;
      padding: 19px 15px 20px;
      box-sizing: border-box;
      margin-top: 15px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .icon-img {
        width: 56px;
        margin-left: 8px;
      }

      .text {
        font-size: 18px;
        font-weight: 800;
        line-height: 25px;
      }
    }
  }
}

.txn-list-wrapper {
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 26px;
    font-weight: 800;
    line-height: 36px;

    .right {
      font-size: 14px;
      font-weight: bold;
      color: $color-text-default-button;
      line-height: 32px;
      cursor: pointer;
    }
  }

  // ::v-deep #customTable .el-table__empty-text {
  // padding-left: 0;
  // }

  // ::v-deep #customTable .table-empty {
  //   height: 100px;

  //   .rhcn-table-empty {
  //     display: flex;
  //     align-items: center;
  //     .icon-empty {
  //       display: flex;
  //       align-items: center;
  //       justify-content: center;
  //       width: 44px;
  //       height: 44px;
  //       background: #F4F6F8;
  //       border-radius: 50%;

  //       .icon-kong {
  //         font-size: 24px;
  //         color: rgba($color-text-primary, 0.4);
  //       }
  //     }

  //     .empty-txt {
  //       font-size: 14px;
  //       color: rgba($color-text-primary, 0.4);
  //     }
  //   }
  // }
}

.total-amount-wrapper {
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 26px;
    font-weight: 800;
    line-height: 36px;
  }

  .total-amount-content {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100px;
    background: linear-gradient(270deg, #F9FCFF 0%, #EFF5FA 39%, #F9FCFF 100%);
    border-radius: 8px;
    padding: 20px;
    box-sizing: border-box;
    overflow: hidden;

    .img-total-amount {
      position: absolute;
      bottom: -36px;
      right: 60px;
      width: 287px;
      height: 112px;
    }

    .total-amount-content-top {
      display: flex;
      align-items: center;

      .total-amount {
        display: flex;
        align-items: center;
        font-size: 26px;
        font-family: Avenir-Heavy, Avenir;
        font-weight: 800;
        color: $color-text-primary;
      }

      .currency-select {
        width: 84px;
        height: 31px;
        background: white;
        border-radius: 2px;
        box-sizing: border-box;
        border: 1px solid transparent;

        &.total-currency-select {
          background: transparent;

          ::v-deep &.el-select .el-input__inner {
            color: $color-text-primary;
            background-color: transparent;
            border: none;
            font-size: 20px;
            height: 31px;
            font-weight: 900;
          }

          ::v-deep .el-select__caret {
            color: $color-text-primary;
          }

          &:hover {
            background: white;
            border: 1px solid $color-border-active;
          }
        }

        ::v-deep &.el-select .el-input__inner {
          font-weight: bold;
          color: $color-text-primary;
          background-color: white;
        }
      }
    }

    .total-amount-content-bottom {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: $color-text-primary;
      line-height: 20px;
    }
  }
}

@media screen and (max-width: 992px) {
  .balance-wrapper {
    margin-bottom: 15px;
    width: 100%;

    .balance-title-wrapper {
      .title {
        font-size: 20px;
      }

      .buttons {
        display: none;
      }
    }

    .balance-list {
      height: 120px;
      overflow: auto;

      &.pc {
        display: none;
      }

      &.mobile {
        display: block;
      }

      .balance-item {
        min-width: 180px;
        margin-right: 10px;
        height: 120px;
        padding: 14px 10px 10px;

        .amount {
          font-size: 20px;
          margin-top: 10px;
          line-height: 27px;
        }

        .currency-name {
          margin-top: 0;
          font-size: 14px;
          line-height: 19px;
        }

        .currency-img {
          width: 33px;
        }
      }
    }
  }

  .summary-amount-wrapper {
    &.pc {
      display: none;
    }

    &.mobile {
      display: block;
      background: #F4F6F8;
      padding: 10px 20px;
      width: 100vw;
      transform: translateX(-10px);

      .top {
        display: flex;
        align-items: center;

        .time {
          font-size: 16px;
          font-weight: 500;
          line-height: 28px;
          white-space: nowrap;
          margin-right: 20px;
        }

        .currency {
          width: 75px;
        }
      }

      .bottom {
        display: flex;
        align-items: center;
        margin-top: 10px;

        .amount {
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;

          label {
            font-size: 14px;
            margin-right: 10px;

            .i-popover {
              color: #43618A;
              opacity: 0.7;
            }
          }

          &:first-child {
            margin-right: 35px;
          }
        }
      }
    }
  }

  .summary-wrapper {
    margin-bottom: 15px;

    .title {
      font-size: 20px;
      font-weight: 600;
      line-height: 28px;
      margin-bottom: 10px;
    }

    .summary-item {
      margin-right: 0;
    }

    &.pc {
      display: none;
    }

    &.mobile {
      display: block;

      .content {
        // box-shadow: 1px 2px 8px 1px #F6F8FA;
        background: $color-balance-bg;
        border-radius: 12px;
        padding: 10px 15px 15px 15px;
        height: inherit;

        &.amount-content {
          display: flex;
          flex-direction: column;
          height: 399px;
        }

        .tip-list-mobile {
          display: flex;

          .tip-item {
            width: 50%;
            padding: 20px 15px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            &:first-child {
              border-right: 1px solid #D4D9E3;
            }

            .left-wrapper {
              .left-top {
                display: flex;
              }

              .iconfont {
                font-size: 36px;
                margin-right: 10px;
              }

              .icon-xingzhuangjiehe {
                color: #7C86D8;
              }

              .icon-xingzhuangjiehe2 {
                color: #EF9E8D;
              }

              .tip-content {
                font-size: 20px;
                font-weight: 600;
                line-height: 28px;
                margin-bottom: 4px;
                white-space: nowrap;
              }

              .tip-content-sub {
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                white-space: nowrap;
              }

              .bottom {
                margin-top: 29px;
                padding-left: 46px;
              }

              .count {
                font-size: 24px;
                font-weight: 600;
                line-height: 33px;
              }

              .unit {
                font-size: 14px;
                font-weight: 400;
                line-height: 33px;
                margin-left: 3px;
              }
            }

            .right-wrapper {
              padding-left: 0 !important;

              .item {
                margin-right: 10px;
              }

              .icon-lujing {
                font-size: 20px;
                color: rgba(38, 67, 115, 0.6);
              }
            }
          }
        }
      }
    }
  }

  .txn-wrapper {
    &.pc {
      display: none;
    }

    &.mobile {
      display: block;

      .title-wrapper {
        display: flex;
        padding-top: 15px;
        align-items: center;
        justify-content: space-between;

        .title {
          font-size: 20px;
          font-weight: 600;
          line-height: 34px;
        }

        .icon-eye {
          color: $color-primary;
        }
      }

      .tabs {
        border-radius: 10px;
        display: flex;

        .tab {
          width: 50%;
          height: 50px;
          font-size: 16px;
          font-weight: 600;
          line-height: 50px;
          text-align: center;
          background: #F4F6F8;
          color: #3E6EB0;

          &:first-child {
            border-top-left-radius: 10px;
            border-bottom-left-radius: 10px;
          }

          &:last-child {
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
          }

          &.active {
            color: #FFFFFF;
            background-color: #01A2DD;
          }
        }
      }

      .sub-tab-btns {
        text-align: center;
        margin-top: 15px;
        margin-bottom: 15px;

        .btn {
          padding-right: 15px;
          padding-left: 15px;
          color: #264373;

          &.active {
            color: #01A2DD;
          }
        }
      }

      .chart-box {
        background: #F4F6F8;
        // box-shadow: 1px 2px 10px 2px rgba(233,233,233,0.5);
        border-radius: 12px;
        height: 320px;

        .txn-subtitle-wrapper {
          .date {
            font-size: 16px;
          }
        }

        .overview-title,
        .overview-subtitle {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
    }
  }

  .entrance-wrapper {
    .content-list {
      display: block;
      width: 100%;
      overflow: auto;
      white-space: nowrap;

      .content-item {
        width: 200px;
        height: 170px;
        margin-right: 10px;
        border-radius: 12px;
        display: inline-flex;

        .text {
          display: block;
        }
      }
    }
  }
}

.success-temporary {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 38px;
  height: 100%;
}
</style>
<style lang="scss">
@import '@/styles/variables.scss';

.index-balance-item-operation {
  padding: 10px 6px;
  border-radius: 10px;
}

.balance-item-operation-box {
  .balance-item-operation {
    display: flex;
    align-items: center;
    height: 34px;
    padding: 0 10px;
    cursor: pointer;
    color: $color-text-primary;
    font-weight: 600;
    font-size: 14px;
    box-sizing: border-box;

    &:hover {
      background-color: $color-text-primary;
      color: white;
    }
  }
}
</style>
